import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { KeyIcon, ArrowRightIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-navy-900 py-16 md:py-24 relative overflow-hidden" ref={ref} data-id="element-252">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-253" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-254" />
      <div className="absolute top-1/2 -translate-y-1/2 -right-32 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-255" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-257">
          <div className="flex items-center gap-3 mb-4" data-id="element-258">
            <KeyIcon className="w-6 h-6 text-gold-500" aria-hidden="true" data-id="element-259" />
            <span className="font-body text-gold-500 text-sm font-semibold tracking-widest uppercase" data-id="element-260">
              El Mecanismo
            </span>
          </div>

          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4" data-id="element-261">
            El Mapa de{' '}
            <span className="text-gold-500" data-id="element-262">Dependencia Secuencial</span>
          </h2>

          <div className="w-20 h-1 bg-gold-500 mb-8" data-id="element-263" />

          <p className="font-body text-lg sm:text-xl text-navy-100 leading-relaxed mb-8" data-id="element-264">
            Este sistema no es una guía de consejos —{' '}
            <strong className="text-white" data-id="element-265">
              es un protocolo operativo de ingeniería inversa.
            </strong>{' '}
            Hemos descifrado exactamente qué trámite abre la puerta al
            siguiente.
          </p>

          {/* Sequential chain visualization */}
          <div className="bg-navy-800/60 border border-navy-700 rounded-xl p-6 sm:p-8" data-id="element-266">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 font-body text-base" data-id="element-267">
              <div className="flex items-center gap-3" data-id="element-268">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gold-500 text-navy-900 font-bold text-sm flex-shrink-0" data-id="element-269">
                  1
                </span>
                <span className="text-white font-medium" data-id="element-270">Hora 4</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-gold-500 hidden sm:block flex-shrink-0" aria-hidden="true" data-id="element-271" />
              <div className="flex items-center gap-3" data-id="element-272">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gold-500 text-navy-900 font-bold text-sm flex-shrink-0" data-id="element-273">
                  2
                </span>
                <span className="text-white font-medium" data-id="element-274">
                  Hora 48: Cuenta bancaria
                </span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-gold-500 hidden sm:block flex-shrink-0" aria-hidden="true" data-id="element-275" />
              <div className="flex items-center gap-3" data-id="element-276">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gold-500 text-navy-900 font-bold text-sm flex-shrink-0" data-id="element-277">
                  3
                </span>
                <span className="text-white font-medium" data-id="element-278">Día 15: Vivienda</span>
              </div>
            </div>
          </div>

          <p className="font-body text-navy-200 leading-relaxed mt-6" data-id="element-279">
            Sabrás qué necesitas obtener en la hora 4 para poder abrir tu cuenta
            de banco en la hora 48, y qué documento bancario necesitas para
            asegurar tu vivienda permanente en el día 15.{' '}
            <strong className="text-gold-400" data-id="element-280">
              Es una reacción en cadena diseñada para darte estabilidad en
              tiempo récord.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}